import {ValueObject} from '@s-ui/domain'

/**
 * Maybe a dealer can be also an user and we can return both fulfilled
 */
export class SellerValueObject extends ValueObject {
  /**
   * @param {Object} param
   * @param {Number|String} param.contractId
   * @param {Boolean} param.isDealer
   * @param {Boolean} param.isPrivate
   * @param {DealerEntity} param.dealer
   * @param {UserEntity} param.user
   */
}
